import store from '../store';
import {i18n} from '../plugins/i18n'
export default function (to, from ,next) {
    return new Promise((resolve , reject) => {
        if(!store.getters.activeWebsite){
            /*store.commit('app/ADD_MESSAGE', {text: i18n.t('Select your active website, or create one.'), type: 'info'});*/
            /*resolve({redirect: '/websites'});*/
        }
        resolve(true);
    })
}
